import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { EditPermissions } from '../../../../../../../shared/models';
import { required } from '../../../../../../../shared/utils';
import { getEditTypes } from '../../../delegatorUtils';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';

export interface DateFormatData {
  name: string,
  description: string,
  variableName: string,
  patternFrom: string,
  patternTo: string,
  yes: string,
  no: string
}

export const NODE_TYPE = 'dateFormat';

export class DateFormat {

  action: any = {};

  constructor(formData: DateFormatData) {
    this.action = {
      'actionType': NODE_TYPE,
    };
    this.setNodeData(formData);
  }

  static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): UntypedFormGroup {
    const { editMenuTextOnly, editFlows } = getEditTypes(editPermissions);
    const formData = this.getFromData(stepData);

    return this.buildForm(formData, editFlows);
  }

  private static getFromData(stepData: { [index: string]: any }): DateFormatData {
    const action = stepData?.action ? stepData?.action : {};
    const actionParams = action?.actionParams ? action?.actionParams : {};
    const result = action?.result ? action?.result : {};

    return {
      name: action.name ? action.name : '',
      description: action.description ? action.description : '',
      variableName: actionParams.variableName ? actionParams.variableName : '',
      patternFrom: actionParams.patternFrom ? actionParams.patternFrom : '',
      patternTo: actionParams.patternTo ? actionParams.patternTo : '',
      yes: result.yes ? result.yes : newStepValue,
      no: result.no ? result.no : newStepValue,
    };
  }

  private static buildForm(formData: DateFormatData, editFlows: boolean): UntypedFormGroup {
    return new UntypedFormGroup({
      name: new UntypedFormControl({
        value: formData.name,
        disabled: !editFlows,
      }, required('Name')),
      description: new UntypedFormControl({
        value: formData.description,
        disabled: !editFlows,
      }, required('Description')),
      variableName: new UntypedFormControl({
        value: formData.variableName,
        disabled: !editFlows,
      }, required('Variable Name')),
      patternFrom: new UntypedFormControl({
        value: formData.patternFrom,
        disabled: !editFlows,
      }, required('Pattern From')),
      patternTo: new UntypedFormControl({
        value: formData.patternTo,
        disabled: !editFlows,
      }, required('Pattern To')),
      yes: new UntypedFormControl(formData.yes),
      no: new UntypedFormControl(formData.no),
    });
  }

  get nodeData(): {} {
    return {
      action: this.action,
      'type': 'action',
      metadata: {
        nodeVersion: '1.0.0',
      },
    };
  }

  setNodeData(formData: DateFormatData) {
    const { name, variableName, description, yes, no, patternTo, patternFrom } = formData;

    const actionParams = {
      variableName,
      patternTo,
      patternFrom,
    };

    const result = {
      yes,
      no,
    };

    this.action = {
      ...this.action,
      name,
      description,
      actionParams,
      result,
    };
  }
}
